import axios from 'axios';

export const directusUrl = process.env.DIRECTUS_URL;

export type Language = 'de' | 'en' | 'pl';

interface FooterResponse {
    brand: {
        name: string;
    };
    type: {
        type: 'footer';
    };
    items: FooterItem[];
}
interface FooterItem {
    menu_item_id: {
        icon: null;
        translations: FooterTranslation[];
        children: FooterChildren[];
        is_link_external: boolean;
    };
}

export interface ICompany {
    id: number;
    phone: string;
    country: string;
    zip_code: string;
    town: string;
    street: string;
    full_name: string;
    short_name: string;
}

export type Social = 'facebook' | 'linkedin' | 'instagram';

export interface FooterChildren {
    related_menu_item_id: {
        translations: FooterTranslation[];
        children: FooterChildren[];
        is_link_external: boolean;
    };
}
export interface FooterTranslation {
    name: string;
    slug: null | string;
    languages_code: Language;
    id: number;
    menu_item_id: number;
}

export interface FooterSocialItem {
    menu_item_id: {
        translations: FooterTranslation[];
        icon: {
            icon: Social;
        };
    };
}

export const getFooter = async (): Promise<FooterResponse> => {
    const response = await axios.get(
        `${directusUrl}/items/menu?fields=brand.name,type.type,items.menu_item_id.icon.icon,items.menu_item_id.translations.*,items.menu_item_id.children.related_menu_item_id.is_link_external,items.menu_item_id.children.related_menu_item_id.translations.*,items.menu_item_id.children.related_menu_item_id.children.related_menu_item_id.translations.*&filter[brand][name][_eq]=sagiton.pl&filter[type][type][_eq]=footer`
    );
    return response.data.data[0];
};

export const getSocials = async (): Promise<FooterSocialItem[]> => {
    const response = await axios.get(
        `${directusUrl}/items/menu?fields=brand.name,type.type,items.menu_item_id.icon.icon,items.menu_item_id.translations.*,items.menu_item_id.children.related_menu_item_id.translations.*,items.menu_item_id.children.related_menu_item_id.children.related_menu_item_id.translations.*&filter[brand][name][_eq]=sagiton.pl&filter[type][type][_eq]=socials`
    );
    return response.data.data[0]?.items || [];
};

export const getCompanyData = async (): Promise<ICompany> => {
    const response = await axios.get(
        `${directusUrl}/items/company?fields=*,contacts.*`
    );
    return response.data.data[0];
};
